module.exports = __webpack_public_path__ + "static/Roboto-Light-3bf4e4d34a3d056c9e7cb0bf885ac9d2.woff2";